import { render } from "./TestStorePage.vue?vue&type=template&id=156093c3"
import script from "./TestStorePage.vue?vue&type=script&lang=js"
export * from "./TestStorePage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__